import { z } from "@/zod";
import { createNonNegativeDecimalStringSchema } from "@/schemas/commonFields/numberSchema";

const projectLimitFormNumberSchema = createNonNegativeDecimalStringSchema(3);

export const ProjectLimitFormSchema = z.object({
  stores: z.record(
    z.string().length(26),
    z.record(
      z.string(),
      z.object({
        id: z.string().length(26).optional(),
        hours: projectLimitFormNumberSchema,
        rate: projectLimitFormNumberSchema,
        addition: projectLimitFormNumberSchema,
      }),
    ),
  ),
  period: z.string().date(),
});
